import request from '@/router/axios'

const pre_fix = "/dotadmin/dotadmin/marking/"


export function getTJInfo(id) {
  return request({
    url: pre_fix + 'tj/'+id,
    method: 'get'
  })
}

export function pageTask(query) {
  return request({
    url: pre_fix + 'task/page',
    method: 'get',
    params: query
  })
}


export function detailTask(id) {
  return request({
    url: pre_fix + 'task/detail/' + id,
    method: 'get',
  })
}


export function dabiaoStart(flowInfo) {
  return request({
    url: pre_fix + 'start/' + flowInfo.flowId,
    method: 'post',
    params: flowInfo
  })
}

export function check(flowId) {
  return request({
    url: pre_fix + 'check/' + flowId,
    method: 'get',
  })
}

export function finish(flowId, orderId) {
  return request({
    url: pre_fix + 'finish/' + flowId,
    params: {orderId: orderId},
    method: 'post',
  })
}


export function configList() {
  return request({
    url: pre_fix + 'config',
    method: 'get',
  })
}

